import { render } from "./CompanyRecurringTransactionsList.vue?vue&type=template&id=06ff4bad"
import script from "./CompanyRecurringTransactionsList.vue?vue&type=script&lang=js"
export * from "./CompanyRecurringTransactionsList.vue?vue&type=script&lang=js"

import "@/modules/company/styles/CompanyRecurringTransactionsList.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__